import { SeverityLevelContact } from './severity-level-contacts';

export const NOC_SEVERITY_LEVEL_CONTACTS: SeverityLevelContact[] = [
  {
    severity: '1<sup>st</sup> Level',
    contacts: [
      {
        name: 'NOC Assigned Technician',
        phones: [{ number: '+1 866 892 0915', type: 'OFF' }],
        email: 'CBNnoc@comcast.com',
      },
    ],
  },
  {
    severity: '2<sup>nd</sup> Level',
    link: '2nd-level',
    generalEmail: 'CBNnocmanagers@comcast.com',
    contacts: [
      {
        name: 'Doug Kozak',
        title: 'NOC Manager',
        phones: [{ number: '+1 773 364 3180', type: 'OFF' }],
      },
      {
        name: 'Fabricio Jimenez',
        title: 'NOC Manager',
        phones: [{ number: '+1 872 215 5848', type: 'OFF' }],
      },
      {
        name: 'Laura Monge',
        title: 'NOC Manager',
        phones: [{ number: '+1 872 702 5027', type: 'OFF' }],
      },
      {
        name: 'Andres Camacho',
        title: 'NOC Manager',
        phones: [{ number: '+1 773 770 1372', type: 'OFF' }],
      },
      {
        name: 'Oscar Chavez',
        title: 'NOC Manager',
        phones: [{ number: '+1 872 702 5028', type: 'OFF' }],
      },
    ],
  },
  {
    severity: '3<sup>rd</sup> Level',
    link: '3rd-level',
    contacts: [
      {
        name: 'Javier Chacon',
        title: 'NOC Director',
        phones: [{ number: '+1 773 364 3175', type: 'OFF' }],
        email: 'Javier_ChaconMonge@comcast.com',
      },
      {
        name: 'Phil Lukacek',
        title: 'NOC Director',
        phones: [
          { number: '+1 312 924 7729', type: 'OFF' },
          { number: '+1 708 285 1179', type: 'CEL' },
        ],
        email: 'Phillip_Lukacek@comcast.com',
      },
    ],
  },
  {
    severity: '4<sup>th</sup> Level',
    link: '4th-level',
    contacts: [
      {
        name: 'Mauricio Lizano',
        title: 'VP of NOC',
        phones: [
          { number: '+1 214 275 9246', type: 'OFF' },
          { number: '+506 8821 6575', type: 'CEL' },
        ],
        email: 'Mauricio_LizanoSaborio@comcast.com',
      },
    ],
  },
  {
    severity: '5<sup>th</sup> Level',
    link: '5th-level',
    contacts: [
      {
        name: 'Jason Wiley',
        title: 'Sr. Director, Escalations Management',
        phones: [
          { number: '+1 312 253 4368', type: 'OFF' },
          { number: '+1 312 656 3481', type: 'CEL' },
        ],
        email: 'Jason_Wiley@comcast.com',
      },
    ],
  },
  {
    severity: '6<sup>th</sup> Level',
    contacts: [
      {
        name: 'Lawrence Edmond',
        title: 'SVP of Engineering',
        phones: [
          { number: '+1 773 364 3189', type: 'OFF' },
          { number: '+1 219 798 6414', type: 'CEL' },
        ],
        email: 'Lawrence_Edmond@comcast.com',
      },
    ],
  },
  {
    severity: '7<sup>th</sup> Level',
    contacts: [
      {
        name: 'Margi Shaw',
        title: 'CEO',
        phones: [{ number: '+1 630 800 9275', type: 'CEL' }],
        email: 'CBNceo@comcast.com',
      },
    ],
  },
];
